import { TextAccordionProps } from "./types"
import React from "react"
import { Accordion } from "~widgets/accordion"
import { AccordionText } from "~components/text"
import styled from '~/ui/styled'

const LeftIconWrap = styled.Pressable`
  margin-right: 10px;
`

const TextAccordion: React.FC<TextAccordionProps> = ({
  accordionProps,
  textProps,
  onTextPress,
  children,
}) => {
  return (
    <Accordion {...accordionProps}>
      <LeftIconWrap onClick={() => onTextPress?.()}>
        <AccordionText {...textProps} />
      </LeftIconWrap>
      {children}
    </Accordion>
  )
}
export default TextAccordion
